module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_0@2x.bce6209f.png";